module.exports = __webpack_public_path__ + "src/assets/img/infotikxLogo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/infotikxLogo.svg
// module id = OIFA
// module chunks = 80